import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { 
  Person as PersonIcon,
  Close as CloseIcon,
} from '@mui/icons-material';
import { useAssets } from '../../../utils/reactQuery/domainAssets';
import Avatar from '../../Avatar';

const ChatHeader = ({
  isUserInfoSubmitted,
  connectionState,
  onMinimize,
  onClose,
}) => {
  
  const { icon } = useAssets();
  return (
    <Box className="chat-header">
      <Box className="chat-header-content">
        <Avatar className="chat-avatar" user_image={icon}/>
        <Box className="chat-header-text">
          <Typography variant="h6" className="chat-title">
            Taskboard Assistant
          </Typography>
          <Box className="chat-subtitle-container">
            <Typography variant="caption" className="chat-subtitle">
              We're here to help!
            </Typography>
          </Box>
        </Box>
      </Box>
      <Box className="chat-header-actions">
        <IconButton
          onClick={onClose}
          size="small"
          className="close-button"
        >
          <CloseIcon />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ChatHeader;
